import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Link, useHistory } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { RatingView } from 'react-simple-star-rating'
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import hsk from '../../../../src/images/hsk.png'

const Course = (props) => {
    const { courseName, description, author, star, image, _id, price } = props.course;
    // console.log(props.product);

    const history = useHistory()
    const handleDetails = (id) => {
        const uri = `/purchase/${_id}`
        console.log(uri)
        history.push(uri)
    }
    return (
        <Grid item xs={4} sm={4} md={4} className="mb-5">
            <Card elevation={10} data-aos="fade-up" data-aos-easing="ease-out-cubic"
                data-aos-duration="2000" sx={{ minWidth: 275, }}  >
                <CardMedia
                    component="img"
                    style={{ width: "100%", height: '70%', margin: "0 auto" }}
                    image={image}
                    alt="Course Image"
                />

                <CardContent data-aos="flip-up" data-aos-duration="1000">
                    <Stack direction="row" spacing={1}>

                        <Chip label="Beginner" color="primary" />

                    </Stack>

                    <Typography data-aos="fade-up" variant="h5" component="div" sx={{ mb: 2 }}>
                        {courseName}
                    </Typography>
                    <Typography color="text.secondary" variant="body2">
                        {/* {description.split(' ').slice(0, 30).toString().replace(/,/g, ' ')}... See more */}
                    </Typography>
                    <RatingView ratingValue={star} /* RatingView Props */ />
                </CardContent>
                <Box data-aos="zoom-in-left" data-aos-duration="3000" sx={{ display: 'flex', justifyContent: 'space-around', borderTop: "1px solid #ddd", pt: 2 }}>
                    <Typography variant="h5" component="div" sx={{ mb: 2 }}>
                        <span style={{ color: 'red' }}>$</span>{price}
                    </Typography>
                    <Box style={{ textDecoration: 'none' }} onClick={() => handleDetails(_id)}><Button sx={{ color: 'red' }} variant="text">View Details</Button></Box>
                </Box>
            </Card>
        </Grid>
    );
};

export default Course;